import type { Artifact } from '@/config/objects/artifacts';
import { useOutletContext } from 'react-router-dom';

interface ArtifactContext {
  artifact: Artifact | undefined;
  isLoading: boolean;
}

export function useArtifactContext() {
  return useOutletContext<ArtifactContext>();
}
